<template>
    <div class="input-form form">
      <div class="form-group" v-for="(item,index) in formItems" :key="index">
          <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.city.$error"
            :error-label="getErrorLabel($v.form.city, 'city')">
            <q-input
              v-model="form.city"
              @blur="$v.form.city.$touch"
              :class="{'invalid-class': $v.form.city.$error}"
              :float-label="item.label"></q-input>
          </q-field>
      </div>
    </div>
</template>

<script>
    import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel.js';
    export default {
        name: 'form-easy',
        components: {},
        mixins: [getErrorLabelMixin],
        data() {
            return {};
        },
        props: {},
        watch: {},
        computed: {},
        created() {
        },
        mounted() {
        },
        destroyed() {
        },
        methods: {},
    };
</script>

<style lang="stylus" scoped>

</style>
